import React from 'react'
import { useStore } from '../../Stores/store';
import { observer } from 'mobx-react-lite';
import { NavLink } from 'react-router-dom';
import { NavBarLink } from './NavBarLink';

interface props {
    links : NavBarLink[]
}

export default observer(function DesktopNavBar({links} : props){
    const { posterStore } = useStore();
    const { currentPoster, setIsPosterActive, closePoster, isPosterActive } = posterStore;

    return (
        <nav>
            <ul onClick={() => {if(isPosterActive) {
                if(currentPoster){
                    closePoster(currentPoster?.id);
                }
            }}}>
                {links.map((link, index) => { return <li key={`${link.title}_${index}_item`}><NavLink className="block !text-white text-center no-underline px-4 py-3.5 hover:bg-neutral-900 [&.active]:!text-white" key={`${link.title}_${index}`} to={link.href}>{link.title}</NavLink></li>})}
                {
                    currentPoster ? <li key="posterLink"><button type="button" className="block text-red-500 text-center appearance-none bg-transparent border-0 outline-none px-4 py-3.5 cursor-pointer font-inherit tracking-inherit hover:bg-neutral-900" onClick={() => setIsPosterActive(true)}>Featured Event</button></li> : <></>
                }
            </ul>
        </nav>
    )
});
